export const redirectAfterLogin = (role) => {
  let path = '/landing';

  switch (role) {
    case 'customer':
    case 'admin':
    case 'surveyor':
    case 'sampler':
    case 'preparator':
    case 'tester':
    case 'technical-manager':
      path = '/orders';
      break;
    case 'document-manager':
      path = '/documents';
      break;
    case 'super-admin':
      path = '/users';
      break;
  }

  return path;
};

export const convertDashCaseToTitleCase = (str) => {
  return str
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const vueSession = window.localStorage.getItem('vue-session-key');

export const getSessionData = (key) => {
  const vueSessionObject = JSON.parse(vueSession || '{}');

  return vueSessionObject[key];
};

export const getRoleLabel = (role) => {
  switch (role) {
    case 'customer':
      return 'Customer';

    case 'admin':
      return 'Administrator';

    case 'surveyor':
      return 'Surveyor';

    case 'sampler':
      return 'Sampler';

    case 'preparator':
      return 'Preparator';

    case 'tester':
      return 'Tester';

    case 'technical-manager':
      return 'Technical Manager';

    case 'document-manager':
      return 'Document Manager';

    case 'super-admin':
      return 'Super Admin';

    default:
      return 'Unknown';
  }
};
